// Presentation routing only. API authorization remains server-owned.
import { APP_TARGET } from "@/lib/nativeApp";

export const partnerEntry = "https://partners.toukky.com/";

/** Where "Become a partner" goes: the partner host in production, the in-app
 * route on a local or staging host that has no partner hostname of its own. */
export function partnerEntryFor(hostname = window.location.hostname) {
  const host = String(hostname).toLowerCase().split(":")[0];
  const local = host === "localhost" || host === "127.0.0.1" || host.endsWith(".localhost") || /^\d+\.\d+\.\d+\.\d+$/.test(host);
  return local || (!host.endsWith("toukky.com") && host !== "") ? "/partners" : partnerEntry;
}
export function isPartnerHost(hostname = window.location.hostname) {
  // The Toukky Partner app is built for the partner portal: it opens there,
  // whatever address its web view reports.
  if (APP_TARGET === "partner") return true;
  const host = String(hostname).toLowerCase().split(":")[0];
  return ["partners.toukky.com", "partners.localhost", "partners.127.0.0.1"].includes(host);
}

export function isPartnerPath(path) {
  return path === "/partners" || path.startsWith("/partners/") || path.startsWith("/partner/");
}
